import React from "react";
import { Modal, Typography, Space, Button } from "antd";
import { WarningOutlined, VideoCameraOutlined } from "@ant-design/icons";
import { CHART_COLORS } from "../../../../Utils/chartColors";
import "./modals.scss";

interface CameraBlockedModalProps {
  open: boolean;
  onAcknowledge: () => void;
  reason: string | null;
}

const CameraBlockedModal: React.FC<CameraBlockedModalProps> = ({
  open,
  onAcknowledge,
  reason,
}) => {
  const getMessage = () => {
    switch (reason) {
      case "dark":
        return "Your camera appears to be blocked or in a dark environment. Please ensure your face is clearly visible and well-lit.";
      case "bright":
        return "Your camera appears to be covered with something (like paper or a bright object). Please remove any obstruction.";
      case "uniform":
        return "Your camera feed shows a uniform image. Please ensure nothing is blocking your camera and your face is visible.";
      default:
        return "Camera obstruction detected. Please ensure your camera has a clear view of your face.";
    }
  };

  const getTitle = () => {
    switch (reason) {
      case "dark":
        return "Camera Blocked or Low Light";
      case "bright":
        return "Camera Covered";
      case "uniform":
        return "Camera Obstruction Detected";
      default:
        return "Camera Issue Detected";
    }
  };

  return (
    <Modal
      open={open}
      centered
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={null}
      className="camera-blocked-modal"
      width={420}
    >
      <Space
        direction="vertical"
        align="center"
        style={{ width: "100%", padding: "16px 8px" }}
      >
        <div
          style={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            backgroundColor: `${CHART_COLORS?.error || "#ff4d4f"}15`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <VideoCameraOutlined
            style={{
              fontSize: 40,
              color: CHART_COLORS?.error || "#ff4d4f",
            }}
          />
        </div>

        <Typography.Title
          level={4}
          style={{ margin: "16px 0 8px 0", textAlign: "center" }}
        >
          <WarningOutlined
            style={{
              color: CHART_COLORS?.warning || "#faad14",
              marginRight: 8,
            }}
          />
          {getTitle()}
        </Typography.Title>

        <Typography.Text
          type="secondary"
          style={{ textAlign: "center", display: "block", lineHeight: 1.6 }}
        >
          {getMessage()}
        </Typography.Text>

        <div
          style={{
            marginTop: 8,
            padding: "12px 16px",
            backgroundColor: `${CHART_COLORS?.warning || "#faad14"}10`,
            borderRadius: 8,
            border: `1px solid ${CHART_COLORS?.warning || "#faad14"}30`,
          }}
        >
          <Typography.Text style={{ fontSize: 13 }}>
            <strong>Tips:</strong>
            <ul style={{ margin: "8px 0 0 0", paddingLeft: 20 }}>
              <li>Ensure your face is clearly visible</li>
              <li>Check for good lighting</li>
              <li>Remove any objects covering the camera</li>
            </ul>
          </Typography.Text>
        </div>

        <Button
          type="primary"
          size="large"
          onClick={onAcknowledge}
          style={{ marginTop: 16, minWidth: 200 }}
        >
          I've Fixed It - Continue
        </Button>
      </Space>
    </Modal>
  );
};

export default CameraBlockedModal;





